import React, { useState } from 'react';
import SiteWide from '../Global/SiteWide/SiteWide';
import NavigationItem from './components/NavigationItem/NavigationItem';
import OutsideClickHandler from 'react-outside-click-handler';
import S from './Navigation.styles';
const Navigation = ({ items = [] }) => {
    const [openNav, setOpenNav] = useState('');
    return (React.createElement(S.Container, null,
        React.createElement(SiteWide, null,
            React.createElement(OutsideClickHandler, { onOutsideClick: () => {
                    setOpenNav('');
                } },
                React.createElement(S.List, null, items.map((item) => (React.createElement(NavigationItem, { key: item.id, openNav: openNav, setOpenNav: setOpenNav, ...item }))))))));
};
export default Navigation;
